import '../../sass/plugins/types_of_services.scss';

$(() => {
  const serviceCards = $('.types-of-services .service-card');

  serviceCards.each((_, element) => {
    $(element).addClass('service-card--visible');
  });
});
